export const nav = 1;

export const getStates = (menu = "ipa", other) => {
  const base = menu || "ipa";
  return {
    [base]: {
      nav,
      landing: true,
      menu, // <ui-view/>
      breadcrumbs: true,
      pageHeader: true,
      icon: "tablet",
      title: "iOS App",
      url: "/" + base, // + "?uploaded&mode",
      params: {},
      // rerouteTo: `${base}.list`,
      // authorize: s => s.hasPermission("ViewCatalogs"),
      templateProvider: $stateParams => `<ipa-file-container  />`,
      ...other
    }
  };
};

export default getStates();
